<template>
  <div>
    <InputLabelBase
      v-if="label"
      :label="label"
      :tool-tip="toolTip"
      :helper-text="helperText"
      :description="description"
      :small="small"
    />
    <fieldset class="flex flex-col gap-3">
      <legend class="sr-only">{{ label ?? "radio-group" }}</legend>
      <div
        v-for="(option, idx) in options"
        :key="idx"
        class="group flex cursor-pointer gap-2"
      >
        <label class="flex items-center gap-2">
          <div class="relative flex items-center">
            <input
              :id="labelCleanUp(option)"
              class="peer h-5 w-5 shrink-0 appearance-none rounded border-2 border-grey-400 bg-white checked:border checked:border-green-800 checked:bg-green-800 hover:ring-2 hover:ring-green-800 hover:ring-offset-2 focus:outline-none focus:ring-2 focus:ring-green-800 focus:ring-offset-2"
              type="checkbox"
              :name="label ? labelCleanUp(label) : ''"
              :checked="model?.includes(option)"
              @change="handleChange(option)"
            />
            <IconCheck
              class="absolute left-1/2 top-1/2 hidden h-4 w-4 -translate-x-1/2 -translate-y-1/2 transform fill-white outline-none peer-checked:block"
            />
          </div>

          <span
            class="cursor-pointer"
            :class="small ? 'text-sm' : 'text-base'"
            >{{ option }}</span
          >
        </label>
      </div>
    </fieldset>
    <p v-if="error" class="mb-0 mt-1 text-sm text-rose-700">
      {{ error }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { labelCleanUp } from "@/utils/formValidation";

const model = defineModel<string[]>();
const props = defineProps<{
  label?: string;
  toolTip?: string;
  helperText?: string;
  description?: string;
  small?: boolean;
  error?: string;
  options: string[];
}>();

const handleChange = (option: string) => {
  if (model.value) {
    if (model.value.includes(option)) {
      model.value = model.value.filter((item) => item !== option);
    } else {
      model.value = [...model.value, option];
    }
  }
};
</script>
